/**
 * Claim codes are 20 base32 characters printed on the device card as
 * XXXX-XXXX-XXXX-XXXX-XXXX. People type them off a sticker while sitting in a car,
 * so input is accepted in whatever form it arrives — lowercase, no dashes, extra
 * spaces, a full paste — and echoed back in the grouped form they are reading from.
 * The server normalizes too; this is about not making them feel clumsy.
 */

const GROUPS = 5;
const GROUP_LENGTH = 4;

export const CLAIM_CODE_LENGTH = GROUPS * GROUP_LENGTH;

/** Strip formatting down to the characters that matter. */
export function normalizeClaimCode(raw: string): string {
  return raw.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, CLAIM_CODE_LENGTH);
}

/** Render normalized characters back as XXXX-XXXX-XXXX-XXXX-XXXX. */
export function formatClaimCode(normalized: string): string {
  return normalized.match(/.{1,4}/g)?.join('-') ?? '';
}
